module.exports = __webpack_public_path__ + "static/media/new-user.a65e7407.svg";